export enum EEnFi {
  en = 'en',
  fi = 'fi',
}
export enum EEnFiSupplier {
  en = 'Supplier',
  fi = 'Toimittaja',
}
export enum EEnFiCustomer {
  en = 'Customer',
  fi = 'Tilaaja',
}
export enum EEnFiCustomerCompany {
  en = 'The person/company/association ordering the product from Jenniina',
  fi = 'Tuotteen Jenniinalta tilaava henkilö/yritys/yhdistys',
}
export enum EETermsOfService {
  en = 'Terms of Service',
  fi = 'Käyttöehdot',
}
export enum EEnFiWelcomeToTermsOfService {
  en = 'Welcome to our Terms of Service page. Please read the following terms carefully.',
  fi = 'Tervetuloa käyttöehtosivullemme. Lue seuraavat ehdot huolellisesti.',
}
export enum EEnFiAcceptanceOfTerms {
  en = 'Acceptance of Terms',
  fi = 'Ehtojen hyväksyminen',
}
export enum EEnFiAcceptanceOfTermsText {
  en = 'By accessing and using our service, you accept and agree to be bound by the terms and provision of this agreement.',
  fi = 'Käyttämällä palveluamme hyväksyt ja sitoudut noudattamaan tämän sopimuksen ehtoja ja määräyksiä.',
}
export enum EEnFiChangesToTerms {
  en = 'Changes to Terms',
  fi = 'Muutokset ehtoihin',
}
export enum EEnFiChangesToTermsText {
  en = 'We reserve the right to modify these terms at any time. You should check this page regularly to take notice of any changes we may have made to the Terms of Service.',
  fi = 'Pidätämme oikeuden muuttaa näitä ehtoja milloin tahansa. Sinun tulisi tarkistaa tämä sivu säännöllisesti huomatakseen mahdolliset muutokset, joita olemme tehneet käyttöehtoihin.',
}
export enum EEnFiUseOfService {
  en = 'Use of Service',
  fi = 'Palvelun käyttö',
}
export enum EEnFiUseOfServiceText {
  en = "You agree to use the service only for lawful purposes and in a way that does not infringe the rights of, restrict or inhibit anyone else's use and enjoyment of the service.",
  fi = 'Hyväksyt käyttää palvelua vain laillisiin tarkoituksiin ja tavalla, joka ei loukkaa kenenkään oikeuksia, rajoita tai estä kenenkään muun käyttöä ja nauttimista palvelusta.',
}
export enum EEnFiTermination {
  en = 'Termination',
  fi = 'Päättäminen',
}
export enum EEnFiTerminationText {
  en = 'We may terminate or suspend access to our service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.',
  fi = 'Voimme lopettaa tai keskeyttää pääsyn palveluumme välittömästi ilman ennakkoilmoitusta tai vastuuta mistä tahansa syystä, mukaan lukien rikkoessasi ehtoja.',
}
export enum EContactMeText {
  en = 'If you have any questions about these Terms, please',
  fi = 'Jos sinulla on kysyttävää näistä ehdoista, ole hyvä ja',
}
export enum EContactMe {
  en = 'Contact me',
  fi = 'Ota yhteyttä',
}
export enum EEnFiProductionBeginsWhen {
  en = 'Production begins when the advance payment has been received and the customer has provided the materials required by the product, such as images and texts.',
  fi = 'Tuotteen valmistus alkaa siitä, kun ennakko on vastaanotettu ja tilaaja on toimittanut tuotteen vaatimat materiaalit, kuten kuvat ja tekstit.',
}
export enum EEnFiCustomerResponsibleForCopyright {
  en = 'The customer is responsible for ensuring that they have the right to use all text and image materials used and that they do not infringe the copyrights of third parties.',
  fi = 'Tilaaja vastaa siitä, että tällä on käyttöoikeus kaikkiin käytettyihin teksti- ja kuvamateriaaleihin, eivätkä ne loukkaa kolmansien osapuolten tekijänoikeuksia.',
}
export enum EEnFiSupplierNotResponsibleForErrors {
  en = 'The supplier is not responsible for errors caused by the customer, such as incorrect information or images, or incorrect spelling.',
  fi = 'Toimittaja ei vastaa tilaajan aiheuttamista virheistä, kuten virheellisistä tiedoista, kuvista tai kirjoitusvirheistä.',
}
export enum EEnFiSupplierNotResponsibleForUpdates {
  en = 'The supplier is not responsible for updates after the order has been delivered, but the customer can order an update service from the supplier if necessary.',
  fi = 'Toimittaja ei vastaa päivityksistä tilauksen toimituksen jälkeen, mutta tilaaja voi tarvittaessa tilata toimittajalta päivityspalvelun.',
}
export enum EEnFiOrderIsBinding {
  en = 'The order is binding. The product is published/delivered when it is approved by the customer and the full invoice has been paid and received.',
  fi = 'Tilaus on sitova. Tuote julkaistaan/toimitetaan, kun se on hyväksytty tilaajan puolelta ja koko lasku on maksettu ja vastaanotettu.',
}
export enum EEnFiColorsMayVaryInPrintedWorks {
  en = 'In printed works, it is always possible that the colors do not exactly match the colors displayed on the screen. This is because the screen uses light and the print uses ink. Colors may also vary with different printing materials.',
  fi = 'Tulostetöissä on aina mahdollista, että värit eivät vastaa täysin näytöllä näkyviä värejä. Tämä johtuu siitä, että näytöllä käytetään valoa ja tulosteessa mustetta. Värit voivat myös vaihdella eri tulostusmateriaaleilla.',
}
export enum EEnFiPrintingCostsNotIncluded {
  en = 'Printing costs are not included in the price.',
  fi = 'Painokustannukset eivät sisälly hintaan.',
}
export enum EEnFiSupplierMayUseProductInMarketing {
  en = "The supplier may use the customer's product in their own marketing and portfolio, unless otherwise agreed.",
  fi = 'Toimittaja saa käyttää tilaajan tuotetta omassa markkinoinnissaan ja portfoliossaan, ellei toisin sovita.',
}
export enum EEnFiSupplierMayHelpWithHostingAndPrintingSolutions {
  en = 'The supplier may help with choosing the hosting or printing solutions, but the customer is responsible for the costs of these services.',
  fi = 'Toimittaja voi auttaa valitsemaan hosting- tai painoratkaisuja, mutta tilaaja vastaa näiden palveluiden kustannuksista.',
}
